import { render } from "./ScaleKeyBody.vue?vue&type=template&id=43a5e9fc"
import script from "./ScaleKeyBody.vue?vue&type=script&lang=js"
export * from "./ScaleKeyBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__